import DataTable from 'components/ui/DataTable/data-table';
import PermissionWrapper from 'components/ui/PermissionWapper';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ICoursesInput, useListCoursesQuery } from 'redux/reducers/courses';
import { ActionType } from 'utils/action.type.enum';
import { ModuleCode } from 'utils/module.code.enum';
import DeleteIcon from '../../../../assets/images/icons/delete.png';
import EditIcon from '../../../../assets/images/icons/edit.png';
import session from './assets1/seminar.png';

interface ITraineeDataTable {
  onEditClicked: (data: ICoursesInput) => void;
  onDeleteClicked: (data: ICoursesInput) => void;
  setFormModal: () => void;
  onResourceClicked: (data: ICoursesInput) => void;
  onCourseResourseClicked: (data: string) => void;
  searchQuery: string;
}
const CourseListTable: FC<ITraineeDataTable> = ({
  onEditClicked,
  onDeleteClicked,
  setFormModal,
  onResourceClicked,
  onCourseResourseClicked,
  searchQuery
}) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data: coursesdata, isLoading } = useListCoursesQuery({
    pageNo: page,
    pageSize: 10,
    searchQuery
  });



    const totalRows = coursesdata?.data && coursesdata?.data.length > 0 ? coursesdata?.data?.[0].row_total : 0;
    

  const totalPages = Math.ceil(totalRows / 10);
  const canNext = page < totalPages;
  const canPrevious = page > 1;

  const columns: any = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (data: any) => {
        return <>{page === 1 ? data.row.index + 1 : data.row.index + (page - 1) * 10 + 1}</>;
      }
    },
    {
      Header: ' Module Name',
      accessor: 'title'
    },
    {
      Header: 'Module code',
      accessor: 'code'
    },
        {
      Header: 'Publish',
      accessor: 'publish',
        Cell: (data: any) => {
        return <>{data?.row?.values?.publish ? "Yes":"No"}</>;
      }
    },
    // {
    //   Header: 'Module Resource',
    //   Cell: (data: any) => {
    //     return (
    //       <div className="relative pe-auto">
    //         {data.row.original?.course_resource_list?.map((item: any, index: number) => {
    //           let filename = item.file.substring(item.file.lastIndexOf('/') + 1);
    //           return (
    //             <a
    //               key={index}
    //               onClick={() => onCourseResourseClicked(item.file)}
    //               className={`pe-auto badge badge-soft-info p-2 bg-light text-dark`}
    //             >
    //               {filename}
    //             </a>
    //           );
    //         })}
    //       </div>
    //     );
    //   }
    // },
    {
      Header: 'Action',
      Cell: (data: any) => {
        return (
          <>
          <PermissionWrapper actionType={ActionType.CAN_UPDATE} module_code={ModuleCode.MODULES_AND_SESSION}>

            <img
              src={EditIcon}
              className="icons"
              onClick={() => onEditClicked(data.row.original)}
            />
            </PermissionWrapper>
            {/* <PrimaryButton
              title="Session"
              type="button"
              onClick={() => {
                navigate('/modules/session', {
                  state: { course_id: data.row.original.course_id }
                });
              }} */}

            <img
              src={session}
              className="icons"
              style={{ height: '20px', width: '20px', marginLeft: '10px', cursor: 'pointer' }}
              onClick={() => {
                navigate(`/modules/session/${data.row.original.id}`, {
                  state: { course_id: data.row.original.id }
                });
              }}
            />


            {/* <PrimaryButton
              isDanger
              title="Delete"
              type="button"
              className="m-2"
              onClick={() => {
                onDeleteClicked(data.row.original);
              }} */}
          <PermissionWrapper actionType={ActionType.CAN_DELETE} module_code={ModuleCode.MODULES_AND_SESSION}>

            <img
              src={DeleteIcon}
              className="m-2 icons"
              onClick={() => onDeleteClicked(data.row.original)}
            />
            </PermissionWrapper>
          </>
        );
      }
    }
  ];
  return (
    <div>
      <DataTable
        columns={columns}
        // data={coursesdata?.data?.results || []}
        data={coursesdata?.data || []}
        isLoading={isLoading}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => {
            if (canPrevious) {
              page > 1 && setPage(page - 1);
            }
          },
          nextPage: () => {
            if (canNext) {
              setPage(page + 1);
            }
          }
        }}
        search={false}
      />
    </div>
  );
};

export default CourseListTable;
